import './polyfills'; // must be first
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { createBrowserHistory } from 'history';
import 'office-ui-fabric-core/dist/css/fabric.min.css';
import 'office-ui-fabric-react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import './styles/kendoReact.scss';

initializeIcons();
const history = createBrowserHistory();

ReactDOM.render(<App history={history} />, document.getElementById('root'));
